import { ColumnFilterElementTemplateOptions } from 'primereact/column'
import {
  Dropdown,
  DropdownChangeEvent,
  DropdownProps,
} from 'primereact/dropdown'

import { FileMetaData } from '../../data/models'
import i18n from '../../utils/i18n'
import { EInvoiceStatusTag } from './EInvoiceStatusTag'

export const EInvoiceStatusFilterTemplate = (
  options: ColumnFilterElementTemplateOptions,
) => {
  if (!options) return null

  const { t } = i18n

  const status: FileMetaData['status'][] = [
    'ReadyForCommit',
    // 'Committed', // Don't show this because in e-invoice cockpit and overview there are no committed invoices.
    'UnverifiedInvoice',
    'FailedRulesEngineCheck',
  ]

  const valueTemplate = (option: any, props: DropdownProps) => {
    if (option) {
      return <EInvoiceStatusTag status={option} />
    }

    return <>{props.placeholder}</>
  }

  const itemTemplate = (option: any) => {
    return <EInvoiceStatusTag status={option} />
  }

  return (
    <Dropdown
      value={options.value}
      options={status}
      onChange={(e: DropdownChangeEvent) =>
        options.filterCallback(e.value, options.index)
      }
      valueTemplate={valueTemplate}
      itemTemplate={itemTemplate}
      className="p-column-filter"
      placeholder={t('eInvoiceOverview.table.columns.status.filterPlaceholder')}
    />
  )
}
